import type { MedicalMaster } from "@/gen/medical_master/common_pb";
import { ListMedicalMasterResponse } from "@/gen/medical_master/list_medical_master_pb";
import { Route as MedicalMasterRoute } from "@/routes/company/_layout/inventory/medical-master/index";
import { useQuery } from "@tanstack/react-query";
import { getMedicalMasterItems } from "../-data/api";

interface MedicalMasterQueryResult {
    medicalMasters: MedicalMaster[];
    totalCount: number;
    page: number;
    pageSize: number;
}

export const useMedicalMasterData = () => {
    const searchParams = MedicalMasterRoute.useSearch();

    const page = searchParams.page || 1;
    const pageSize = searchParams.pageSize || 10;

    return useQuery<MedicalMasterQueryResult>({
        queryKey: ["medicalmaster", searchParams],
        queryFn: async () => {
            const search = searchParams.search || "";

            let response: ListMedicalMasterResponse;

            response = await getMedicalMasterItems(page, pageSize, search);

            return {
                medicalMasters: response.medicalMasters,
                totalCount: response. totalCount,
                page,
                pageSize
            };
        },
        // Keep previous data while fetching new data for better UX
        placeholderData: (previousData) => previousData,
        // Don't refetch when window regains focus
        refetchOnWindowFocus: false,
        // Stale time - how long data stays fresh (5 minutes)
        staleTime: 5 * 60 * 1000,
        // Cache time - how long inactive data stays in cache (10 minutes)
        gcTime: 10 * 60 * 1000,
    });
};